import { render, staticRenderFns } from "./BurnRateThresholds.vue?vue&type=template&id=6fc23658&scoped=true"
import script from "./BurnRateThresholds.vue?vue&type=script&lang=js"
export * from "./BurnRateThresholds.vue?vue&type=script&lang=js"
import style0 from "./BurnRateThresholds.vue?vue&type=style&index=0&id=6fc23658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc23658",
  null
  
)

export default component.exports